<template>
  <div>
    <slot 
      v-if="dropdownIsMounted"
      v-bind="{ getItem, disableTeleportList, closeDropdown }"
    />
    <aw-dropdown 
      :class="dropdownClass" 
      :hover="true"
      placement="bottom-end"
      v-model="dropdownOpened"
    >
      <template v-slot:btn="{ open }">
        <slot 
          name="btn"
          v-bind="{ open, getMenuBtn, showMenuBtn }"
        />
      </template>
      <template v-slot:dropdown="{ opened, dropdown }">
        <component 
          v-show="opened" 
          :class="dropdownMenuClass" 
          :id="teleportId"
          :is="dropdownTag"
          :ref="(el) => { dropdownMounted(el, dropdown); }"
        />
      </template>
    </aw-dropdown>
  </div>
</template>

<script>
import throttle from 'lodash/throttle'

export default {
  props: {
    dropdownClass: {
      type: String,
      default: 'dropdown'
    },
    dropdownMenuClass: {
      type: String,
      default: 'dropdown-menu AwPriorityNav__DropdownMenu'
    },
    dropdownTag: {
      type: String,
      default: 'div'
    },
    teleportId: {
      type: String,
      default: 'awMenuDropdown'
    },
  },
  data() {
    return {
      menuBtn: null, // dropdown menu button reference
      disableTeleportList: {}, // list of all items in menu -> false => item is teleported
      slotItems: {}, // menu items
      throttledOnresize: null,
      plannedOnResize: null,
      dropdownHasItems: false, // has dropdown any items?
      menuWrapperObserver: null, // resizeobserver
      dropdownOpened: false, // is dropdown opened?
      dropdownIsMounted: false, // is dropdown mounted?
      working: false, // resize calculation in progress
      slotItemsObserver: null, // observer placed on each item in menu
      showMenuBtn: false, // v-show boolean for menu
    }
  },
  methods: {
    getMenuBtn(el) {
      if (el instanceof HTMLElement) {
        this.menuBtn = el
      } else if (el) {
        this.menuBtn = el.$el
      }
    },
    planOnResize() {
      if (this.plannedOnResize) {
        clearTimeout(this.plannedOnResize)
      }

      this.plannedOnResize = setTimeout(() => {
        this.onResize()
      }, 40);
    },
    getItem(el, index) {
      if (!el || (el && this.slotItems[index] && (this.slotItems[index].el === el || (el.$el && this.slotItems[index].el === el.$el)))) {
        return
      }

      this.disableTeleportList[index] = true
      this.slotItems[index] = {}

      if (el instanceof HTMLElement) {
        this.slotItems[index].el = el
      } else if (el) {
        this.slotItems[index].el = el.$el
      }

      this.planOnResize()

      this.slotItems[index].el.awItemIndex = index
      this.slotItemsObserver.observe(this.slotItems[index].el)
    },
    onResize() {
      if (!this.dropdownIsMounted) {
        this.planOnResize()
        return
      }

      if (this.working) {
        return
      }

      this.working = true
      const keys = Object.keys(this.slotItems)
      const menuWrapperWidth = this.$el.offsetWidth

      if (this.slotItems[keys.length - 1].ends >= menuWrapperWidth) {
        this.showMenuBtn = true
      } else {
        this.showMenuBtn = false
      }

      let menuBtnWidth = this.showMenuBtn && this.menuBtn ? this.menuBtn.offsetWidth : 0
      let someItemsHidden = this.dropdownHasItems

      for (let i = keys.length - 1; i >= 0; i--) {
        if (this.slotItems[keys[i]].ends > menuWrapperWidth - menuBtnWidth) {
          this.disableTeleportList[keys[i]] = false
          someItemsHidden = true
        } else {
          this.disableTeleportList[keys[i]] = true
        }
      }

      if (this.dropdownHasItems !== someItemsHidden) {
        this.dropdownHasItems = someItemsHidden

        this.$nextTick(() => {
          this.throttledOnresize()
        })
      }

      this.working = false
    },
    closeDropdown(curentDropdownClose) {
      if (typeof curentDropdownClose === 'function') {
        curentDropdownClose()
      }

      this.dropdownOpened = false
    },
    dropdownMounted(el, dropdown) {
      if (this.dropdownIsMounted) {
        return
      }
      dropdown(el)
      this.dropdownIsMounted = true
      this.planOnResize()
    }
  },
  created() {
    this.slotItemsObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (this.disableTeleportList[entry.target.awItemIndex] === false) {
          continue
        }

        this.slotItems[entry.target.awItemIndex].ends = entry.target.offsetLeft + entry.target.offsetWidth - this.$el.offsetLeft
      }

      this.throttledOnresize()
    })
  },
  mounted() {
    this.throttledOnresize = throttle(this.onResize, 40)
    this.menuWrapperObserver = new ResizeObserver(this.throttledOnresize)
    this.menuWrapperObserver.observe(this.$el)
  },
  beforeUnmount() {
    this?.menuWrapperObserver?.disconnect()
    this?.slotItemsObserver?.disconnect()
  },
}
</script>

<style lang="scss">
  .AwPriorityNav__DropdownMenu {
    overflow: visible !important;
  }
</style>
